// extracted by mini-css-extract-plugin
module.exports = {"DealEditorFooter":"DealEditorFooter_DealEditorFooter__cCpZB","SaveButton":"DealEditorFooter_SaveButton__8GZzw","Icon":"DealEditorFooter_Icon__2tm8Q"};